import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  Text,
  Textarea,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CiEdit } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { IoIosSend } from "react-icons/io";
const CaseNote = ({ caseData }) => {
  const [caseNotes, setCaseNotes] = useState(caseData || []);
  const [editingIndex, setEditingIndex] = useState(null);
  const [clientPrinciple, setClientPrinciple] = useState(null);
  const { register, handleSubmit, reset, setValue } = useForm();

  // Fetch client principle on mount
  useEffect(() => {
    const fetchClientPrinciple = async () => {
      try {
        const response = await fetch("/.auth/me");
        const data = await response.json();
        setClientPrinciple(data?.clientPrincipal || null);
      } catch (error) {
        console.error("Error fetching client principle", error);
      }
    };
    fetchClientPrinciple();
  }, []);

  // Handle form submission for adding/editing notes
  const onSubmit = (formData) => {
    const note = {
      NOTE: {
        MESSAGE: "Note",
        TYPE: "FreeText",
        VALUE: formData.note,
        EDITABLE: true,
      },
      MODIFIED_DATE: {
        MESSAGE: "Modified",
        TYPE: "Timestamp",
        VALUE: new Date().toLocaleString(),
        EDITABLE: true,
      },
      USER: {
        MESSAGE: "User",
        TYPE: "FreeText",
        VALUE: clientPrinciple?.userDetails?.email || "Anonymous",
        EDITABLE: true,
      },
    };

    if (editingIndex !== null) {
      // Update the existing note
      const updatedNotes = caseNotes.map((item, index) =>
        index === editingIndex ? note : item
      );
      setCaseNotes(updatedNotes);
      setEditingIndex(null);
    } else {
      // Add a new note
      setCaseNotes([...caseNotes, note]);
    }

    reset(); // Clear the form
  };

  // Handle edit note
  const handleEdit = (index) => {
    setEditingIndex(index);
    setValue("note", caseNotes[index]?.NOTE?.VALUE);
  };

  // Handle delete note
  const handleDelete = (index) => {
    const updatedNotes = caseNotes.filter((_, i) => i !== index);
    setCaseNotes(updatedNotes);
  };

  const handleSaveNote = async () => {
    try {
      const response = await fetch("/api/saveCase", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ CASE_NOTES: caseNotes }),
      });

      if (response.ok) {
        toast.success("Case notes saved successfully!");
      } else {
        throw new Error("Failed to save case notes.");
      }
    } catch (error) {
      console.error("Error saving case notes:", error);
      toast.error("Failed to save case notes.");
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex alignItems="end">
          <Textarea
            {...register("note", { required: true })}
            placeholder="Add your note..."
            w="md"
            border="none"
            outline="none"
            ring="none"
            _focus={{
              outline: "none",
              border: "none",
              ring: "none",
              borderBottom: "2px solid gray",
            }}
            borderBottom="2px solid gray"
          />
          <Button type="submit" ml={2}>
            {editingIndex !== null ? "Update" : <IoIosSend fontSize={25} />}
          </Button>
        </Flex>
      </form>

      <Divider my={4} />

      {/* Render the list of notes */}
      {caseNotes.length > 0 ? (
        caseNotes.map((item, index) => (
          <Box key={index}>
            <Flex my={2} gap={2}>
              <Avatar name={item?.USER?.VALUE} src="" />
              <Box>
                <Flex alignItems="center" gap={4}>
                  <Text fontWeight="bold">{item?.USER?.VALUE}</Text>
                  <Box display="flex" alignItems="center" gap={2}>
                    <MdDelete
                      onClick={() => handleDelete(index)}
                      cursor="pointer"
                      color="red"
                    />
                    <CiEdit
                      onClick={() => handleEdit(index)}
                      cursor="pointer"
                      color="blue"
                    />
                  </Box>
                </Flex>
                <Text fontSize="xs" color="gray.400">
                  {item?.MODIFIED_DATE?.VALUE}
                </Text>
                <Text fontSize="sm">{item?.NOTE?.VALUE}</Text>
              </Box>
            </Flex>
          </Box>
        ))
      ) : (
        <Text color="gray.500" mt={4}>
          No notes available.
        </Text>
      )}

      <Divider my={4} />

      {/* Save Changes Button */}
      <Button onClick={handleSaveNote} variant="primary">
        Save Changes
      </Button>
    </Box>
  );
};

export default CaseNote;
